import React, { useState, useEffect, useRef } from 'react'
import { createUseStyles } from 'react-jss'

import SVG from '../../ui/SVG/SVG'

const useStyles = createUseStyles(theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: theme.fontFamily,
    marginBottom: '10px',
    borderBottom: '1px solid #CCCCCC',
    '@media (max-width: 600px)': {
      marginBottom: '3px',
    },
  },

  accordion: {
    backgroundColor: theme.colors.white,
    color: theme.colors.textColor,
    cursor: 'pointer',
    padding: '3px 39px 4px 39px',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    outline: 'none',
    transition: `background-color 250ms ${theme.animations.bezier}`,
    width: '100%',
    '@media (max-width: 700px)': {
      padding: '3px 0',
    },
  },

  accordionActive: {
    backgroundColor: theme.colors.white,
    color: theme.colors.textColor,
    cursor: 'pointer',
    padding: '3px 39px 0 39px',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    outline: 'none',
    transition: `background-color 250ms ${theme.animations.bezier}`,
    width: '100%',
    '@media (max-width: 700px)': {
      padding: '3px 0',
    },
  },

  title: {
    color: theme.colors.blue,
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: '20px',
    textAlign: 'left',
    fontFamily: 'TTRounds',
  },

  icon: {
    backgroundColor: '#F0F0F0',
    boxShadow: '0px 2px 2px 1px rgba(0, 0, 0, 0.12)',
    marginLeft: 'auto',
    borderRadius: '50%',
    width: '30px',
    height: '28px',
    paddingTop: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fill: theme.colors.main,
    color: theme.colors.main,
    '&:hover': {
      fill: theme.colors.white,
      color: theme.colors.white,
      backgroundColor: theme.colors.main,
    },
    '&:active, &:focus': {
      backgroundColor: theme.colors.mainHover,
    },
    '& svg': {
      transform: 'rotate(90deg)',
      transition: `transform 250ms ${theme.animations.bezier}`,
    },
    '@media (max-width: 700px)': {
      transform: 'scale(0.8)',
    },
  },

  iconActive: {
    backgroundColor: '#F0F0F0',
    boxShadow: '0px 2px 2px 1px rgba(0, 0, 0, 0.12)',
    marginLeft: 'auto',
    borderRadius: '50%',
    width: '30px',
    height: '28px',
    paddingTop: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fill: theme.colors.main,
    color: theme.colors.main,
    '&:hover': {
      fill: theme.colors.white,
      color: theme.colors.white,
      backgroundColor: theme.colors.main,
    },
    '&:active, &:focus': {
      backgroundColor: theme.colors.mainHover,
    },
    '& svg': {
      transform: 'rotate(-90deg)',
      transition: `transform 250ms ${theme.animations.bezier}`,
    },
    '@media (max-width: 700px)': {
      transform: 'scale(0.8)',
    },
  },

  content: {
    backgroundColor: '#fff',
    border: 'none',
    overflow: 'hidden',
    transition: `maxHeight 250ms ${theme.animations.bezier}`,
  },

  text: {
    color: theme.colors.textColor,
    fontSize: 16,
    lineHeight: '24px',
    padding: '0px 55px 17px 39px',

    '& p, & div, & li': {
      color: theme.colors.textColor,
      fontSize: 16,
      fontWeight: 300,
      lineHeight: '24px',
      marginBottom: '15px',
    },

    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },

    '& a': {
      fontSize: 16,
      color: theme.colors.main,
      textDecoration: 'underline',

      '&:hover': {
        color: theme.colors.mainHover,
        textDecoration: 'underline',
      },
    },

    '@media (max-width: 700px)': {
      padding: '0 0 15px 0',
      letterSpacing: '0.33px',
      marginTop: 0,
      '& a': {
        fontSize: 16,
      },
      '& p': {
        marginTop: 0,
        marginBottom: 15,
      },
    },
  },
  chevronWrapper: {},
}))

const AccordionItem = props => {
  const { title, body, state, onlyItems } = props
  const [active, setActiveState] = useState(false)
  const [setHeight, setHeightState] = useState('0px')

  const content = useRef(null)

  const classes = useStyles()

  const toggleAccordion = () => {
    setActiveState(!active)
    setHeightState(active ? '0px' : `${content.current.scrollHeight}px`)
  }

  const accordionClasses = active ? classes.accordionActive : classes.accordion
  const iconClasses = active ? classes.iconActive : classes.icon

  useEffect(() => {
    setActiveState(state == '1')
    setHeightState(state == '1' ? `${content.current.scrollHeight}px` : '0px')
  }, [])

  return (
    <div className={classes.main} style={onlyItems ? { borderBottom: 'none' } : {}}>
      <button
        className={accordionClasses}
        style={onlyItems ? { paddingLeft: 10, paddingRight: 10 } : {}}
        onClick={toggleAccordion}
      >
        <p className={classes.title}>{title}</p>
        <div className={`${classes.chevronWrapper} ${iconClasses}`}>
          <SVG name={'Chevron'} width={30} height={18} />
        </div>
      </button>
      <div
        ref={content}
        style={{ maxHeight: `${setHeight}`, ...(onlyItems ? { borderBottom: 'none' } : {}) }}
        className={classes.content}
      >
        <div
          className={classes.text}
          style={onlyItems ? { paddingLeft: 10, paddingRight: 26 } : {}}
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </div>
    </div>
  )
}

export default AccordionItem
